/* Will register additional offset to draw component */
import { Directive, OnInit, AfterViewInit, OnDestroy, ElementRef, Input, HostBinding } from '@angular/core';

import { DrawCollapseService } from './draw-collapse.shared.service';

import { Subscription } from 'rxjs';
import { distinctUntilChanged, combineLatest, auditTime } from 'rxjs/operators';

@Directive({
    selector: '[directive-draw-min-height]',
})
export class DrawMinHeightSharedDirective implements OnInit, AfterViewInit, OnDestroy {
    private _sizeListener$: Subscription;
    private _elem: HTMLElement;
    private _mode: 'register' | 'adjust' = 'register';

    @Input() public activeHeight: boolean = true;
    @HostBinding('style.minHeight.px') public minHeight: number = null;

    constructor(
        private _drawCollapseService: DrawCollapseService,
        private _elementRef: ElementRef,
    ) { }

    ngOnInit(): void {
        if (!this.activeHeight) return;
        this._elem = this._elementRef.nativeElement;

        if (this._elem.getAttribute('directive-draw-min-height') === 'adjust') {
            this._mode = 'adjust';
        }
    }

    ngAfterViewInit(): void {
        if (!this.activeHeight) return;
        setTimeout(() => {
            if (this._mode === 'adjust') {
                this._sizeListener$ = this._drawCollapseService.drawCurrentHeight$.pipe(
                    combineLatest(
                        this._drawCollapseService.minHeightContent$
                    ),
                    // auditTime(0),
                ).subscribe(data => {
                    const sum = data.reduce((a, b) => a + b, 0);
                    this.minHeight = window.innerHeight - sum;
                });
            }
            if (this._mode === 'register') {
                this._drawCollapseService.addMinHeight(this._elem, this._elem.clientHeight);
            }
        }, 0);
    }

    ngOnDestroy(): void {
        if (this._sizeListener$ && !this._sizeListener$.closed) this._sizeListener$.unsubscribe();
    }
}
